import React from "react";

const SubtitleIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
    >
      <defs>
        <clipPath id="clipPath6126212496">
          <path
            d="M0 0L28 0L28 28L0 28L0 0Z"
            fillRule="nonzero"
            transform="matrix(1 0 0 1 0 0)"
          />
        </clipPath>
      </defs>
      <g clipPath="url(#clipPath6126212496)">
        <path
          d="M21 0L2.33333 0C1.05 0 0 1.05 0 2.33333L0 16.3333C0 17.6167 1.05 18.6667 2.33333 18.6667L21 18.6667C22.2833 18.6667 23.3333 17.6167 23.3333 16.3333L23.3333 2.33333C23.3333 1.05 22.2833 0 21 0ZM21 16.3333L2.33333 16.3333L2.33333 2.33333L21 2.33333L21 16.3333ZM4.66667 7L7 7L7 9.33333L4.66667 9.33333L4.66667 7ZM4.66667 11.6667L14 11.6667L14 14L4.66667 14L4.66667 11.6667ZM16.3333 11.6667L18.6667 11.6667L18.6667 14L16.3333 14L16.3333 11.6667ZM9.33333 7L18.6667 7L18.6667 9.33333L9.33333 9.33333L9.33333 7Z"
          fillRule="nonzero"
          transform="matrix(1 0 0 1 2.33333 4.66667)"
          fill="rgb(255, 255, 255)"
        />
      </g>
    </svg>
  );
};

export default SubtitleIcon;
